export default function HeroSection() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmosphere%20with%20warm%20golden%20and%20deep%20crimson%20lighting%2C%20abstract%20film%20reel%20textures%20and%20soft%20bokeh%20effects%2C%20luxurious%20theater%20curtain%20folds%20in%20deep%20red%20and%20black%2C%20elegant%20movie%20premiere%20vibe%20with%20dramatic%20spotlight%20rays%2C%20rich%20velvet%20textures%20and%20golden%20particles%20floating%20in%20air%2C%20sophisticated%20entertainment%20background%20with%20warm%20amber%20glow&width=1920&height=1080&seq=hero-bg-51video&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/75"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="flex flex-wrap gap-2 justify-center lg:justify-start mb-4">
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-accent-500/20 text-accent-300 border border-accent-500/30 whitespace-nowrap">
                <i className="ri-fire-line mr-1"></i>高清不卡顿
              </span>
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-primary-500/20 text-primary-300 border border-primary-500/30 whitespace-nowrap">
                <i className="ri-vip-crown-line mr-1"></i>免费观看
              </span>
              <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-secondary-500/20 text-secondary-300 border border-secondary-500/30 whitespace-nowrap">
                <i className="ri-timer-flash-line mr-1"></i>每日更新
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-white leading-tight mb-3">
              51视频 - 最新电影电视剧免费在线观看平台
            </h1>

            <p className="text-lg md:text-xl text-white/80 font-heading mb-6">
              聚合热门影视资源，畅享高清观影体验
            </p>

            <p className="text-sm md:text-base text-white/65 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              51视频汇聚香蕉视频、红桃视频、91视频等主流影视站点资源，为您提供最新电影、热播电视剧、热门综艺节目的一站式导航服务。无论您是追剧达人还是电影爱好者，都能在这里找到流畅高清的观影入口，告别卡顿与缓冲，尽享沉浸式观影乐趣。
            </p>

            <div className="flex flex-wrap items-center gap-6 justify-center lg:justify-start mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">2000+</div>
                <div className="text-xs text-white/55 mt-1">每日更新影视</div>
              </div>
              <div className="w-px h-10 bg-white/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">1080P</div>
                <div className="text-xs text-white/55 mt-1">高清画质覆盖</div>
              </div>
              <div className="w-px h-10 bg-white/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">0缓冲</div>
                <div className="text-xs text-white/55 mt-1">流畅播放保障</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#index"
                onClick={(e) => handleNavClick(e, '#index')}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg text-sm whitespace-nowrap cursor-pointer transition-all duration-200"
              >
                <i className="ri-play-circle-line text-lg"></i>开始观看
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleNavClick(e, '#ranking')}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white border border-white/25 rounded-lg text-sm whitespace-nowrap cursor-pointer transition-all duration-200"
              >
                <i className="ri-medal-line text-lg"></i>查看排行榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20collage%20with%20warm%20golden%20and%20deep%20red%20tones%2C%20dramatic%20film%20strip%20borders%2C%20elegant%20spotlight%20effects%20on%20dark%20background%2C%20vintage%20theater%20aesthetics%20with%20modern%20streaming%20elements%2C%20rich%20velvet%20curtains%20framing%20the%20composition%2C%20golden%20film%20reel%20and%20clapperboard%20accents%2C%20luxurious%20and%20premium%20entertainment%20brand%20visual%20style&width=800&height=900&seq=hero-visual-51video&orientation=portrait"
                alt="51视频影视聚合平台主视觉"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}